<template src="./Details.html">
</template>

<script>
export default {
    props: {
        itemId: {
            type: Number,
            required: true,
        },
        doctorId: {
            type: Number,
            required: true,
        },
    },
    created() {
        this.$store.dispatch("doctorPrescriptions/getDetails", 
        { id: this.itemId, doctorId: this.doctorId });
    },
    computed: {
        doctorPrescription() {
            return this.$store.state.doctorPrescriptions.doctorPrescription;
        }
    },
    data() {
        return {
            expanded: [],

            headers: [
                { text: 'اسم الدواء', value: 'medicineName' },
                { text: 'الكمية', value: 'dispensedQuantity' },
            ],
        };
    },
};
</script>